import hookup from "./hookup";
import { MockDocumentos } from "../../config";
import { MockBoletasMantencion, MockFactura } from "./documentos.mock";

let path = "api/v2/";

export const SingIn = async (data) => {
    return await hookup("post", `${path}login`, data);
};
export const Recover = async (data) => {
    return await hookup("post", `${path}recover/password`, data);
};
export const UpdatePerfil = async (data) => {
    return await hookup("post", `${path}update/perfil`, data);
};
export const RegisterGetQuestion = async (data) => {
    return await hookup("post", `${path}sinacofi/get/questions`, data);
};
export const RegisterValidateQuestion = async (data) => {
    return await hookup("post", `${path}sinacofi/validate/answer`, data);
};
export const SaveRegister = async (data) => {
    return await hookup("post", `${path}register`, data);
};
export const GetContratoDigital = async (data) => {
    return await hookup("post", `${path}agreements/document`, data);
};

export const ActionBuyTransbank = async (data) => {
    return await hookup("get", `api/mall/start/mi-sendero`, data);
};
export const ActionBuyKhipu = async (data) => {
    return await hookup("post", `/api/payments/khipu/create`, data);
};

export const ActionAcceptarContrato = async (data) => {
    return await hookup("post", `${path}actualizar_aceptantes`, data);
};

export const recaptcha = async (data) => {
    return await hookup("post", `${path}recaptcha`, data);
};

export const GetAvatar = async (rut) => {
    return await hookup("get", `${path}avatar/${rut}`, {});
}

/**
 * Boletas de pago de mantención de un contrato (webservice
 * `obtener_boletas_mnt`). Un contrato puede tener varias boletas, una por
 * cuota pagada.
 *
 * Devuelve sólo identificadores: el path del documento no debe llegar al
 * front — se descarga por `api/v2/documento` (ver DescargarDocumento).
 *
 * @param {{rut: string, contrato: string}} data
 * @returns {Promise<{status: string, result: {boletas: Array<{contrato: string, cuota: number, movimiento: string}>}}>}
 */
export const GetBoletasMantencion = async (data) => {
    if (MockDocumentos) {
        return await MockBoletasMantencion(data);
    }
    return await hookup("get", `${path}boletas-mantencion`, data);
};

/**
 * Factura de un contrato (webservice `obtiene_factura`). Siempre es un único
 * documento, o ninguno. Igual que las boletas, sin el path.
 *
 * @param {{rut: string, contrato: string}} data
 * @returns {Promise<{status: string, result: {factura: Object|null}}>}
 */
export const GetFactura = async (data) => {
    if (MockDocumentos) {
        return await MockFactura(data);
    }
    return await hookup("get", `${path}factura`, data);
};

// Feature flags (`feature_flag`): no van bajo api/v2.
export const GetFeatureFlags = async () => {
    return await hookup("get", `api/feature-flags`, {});
}